
import { parse, isValid } from 'date-fns';
// Utility function to convert strings to title case
export const convertCase = (str) => {
  return str
    .replace(/_/g, ' ')  // Replace underscores with spaces
    .replace(/\b\w/g, match => match.toUpperCase()); // Capitalize the first letter of each word
};

export const getUniqueFilteredData = (data, header) => {
  return data.filter((value, index, self) => {
    return index === self.findIndex((t) => t[header] === value[header]);
  });
};
export const validateDecimal = (value) => {
  const decimalPattern = /^\d{1,10}(\.\d{0,5})?$/;
  if (value.startsWith('0') && value.length > 1) {
    return false;
  }
  return decimalPattern.test(value);
};

export const validateInteger = (value) => {
  const integerPattern = /^\d{1,10}$/;
  return integerPattern.test(value);
};

export const commonFilter = (data, filterHeader, searchValue) => {
  const formatheader = filterHeader.toLowerCase(); // Normalize filterHeader to lowercase

  const filtered = data.filter(item => {
    // Log the keys of the current item
    const itemKeys = Object.keys(item);

    // Find the actual key that matches the formatheader, taking case into account
    const matchingKey = itemKeys.find(key => key.toLowerCase() === formatheader);

    if (matchingKey) {
      const itemValue = item[matchingKey];

      // Handle number and string comparison
      if (typeof itemValue === 'number') {
        return itemValue?.toString().includes(searchValue?.toString());
      }

      if (typeof itemValue === 'string') {
        return itemValue?.toLowerCase().includes(searchValue?.toLowerCase());
      }
    }

    return false;
  });
  return filtered;
}

// Utility function to validate and process decimal inputs
export const validateDecimalInput = (values) => {
  // Convert value to string if it's not already
  values = values ? values.toString() : '';

  // Remove any characters that are not digits, decimal point, or hyphen
  values = values.replace(/[^0-9.]/g, '');
  if (values.startsWith('.') || values.startsWith('-')) {
    values = '0' + values; // Prepend '0' if it starts with a decimal or hyphen
  }

  // Ensure that the decimal point appears only after at least two digits
  if (values.indexOf('.') !== -1) {
    const integerPart = values.split('.')[0];

    // Only allow a decimal point if there are at least two digits before it
    if (integerPart.length < 2) {
      values = values.replace('.', ''); // Remove the decimal if there are less than two digits before it
    } else {
      // Ensure only one decimal point exists
      if (values.indexOf('.') !== values.lastIndexOf('.')) {
        values = values.substring(0, values.indexOf('.') + 1) + values.split('.').slice(1).join('');
      }
    }
  }

  const regex = /^\d{1,10}(\.\d{0,5})?$/;

  // If the value doesn't match the regex, it's invalid
  if (!regex.test(values)) {
    // We want to trim the value to meet the constraints of the regex
    const [integerPart, decimalPart] = values.split('.');

    // Limit the integer part (before decimal) to 10 digits
    const limitedIntegerPart = integerPart.slice(0, 10);

    // Limit the decimal part (after decimal) to 5 digits
    const limitedDecimalPart = decimalPart ? decimalPart.slice(0, 5) : '';

    // Combine the parts back
    values = `${limitedIntegerPart}${limitedDecimalPart ? '.' + limitedDecimalPart : ''}`;
  }

  // Ensure only one decimal point is present
  if (values.indexOf('.') !== values.lastIndexOf('.')) {
    values = values.substring(0, values.indexOf('.') + 1) + values.split('.').slice(1).join('');
  }

  // Prevent invalid starts (like starting with decimal or hyphen)
  if (values.startsWith('.')) {
    values = '0' + values; // Prepend '0' if it starts with a decimal or hyphen
  }

  // Check if values is a valid decimal using regex
  const decimalRegex = /^-?\d*\.?\d*$/;
  if (!decimalRegex.test(values)) {
    return { isValid: false, error: 'Invalid decimal format' };
  }

  // If values starts with 0, and is not just "0" or "0." (like "0123" or "01.23")
  if (values.startsWith('0') && values !== '0' && !values.startsWith('0.')) {
    values = values.slice(1);  // Remove the leading '0'
  }
  // Return the cleaned values if valid
  return { isValid: true, values: parseFloat(values) };
};


const validateField = (data, field, formData) => {
  return data.some(item => item[field] === formData[field]);
};

// Dynamic validation function
export const validateFormData = (validationFields, data, formData) => {
  let newErrorMessage = {};

  validationFields.forEach(field => {
    const isValid = validateField(data, field, formData);

    if (!isValid) {
      newErrorMessage[field] = `Error: ${formData[field]} does not exist in the system.`;
    }
  });

  return newErrorMessage;
};

 export const parseLeadDetails = (detailsString) => {
  const details = {};
  detailsString?.split(',').forEach(part => {
    const [key, value] = part?.split(':').map(str => str.trim());
    if (key && value !== undefined) {
      details[key] = value;
    }
  });
  return details;
};


export const  formatDate=(dateStr)=>{

  if (!dateStr) return 'N/A';
  
  const parsedDate = parse(dateStr, 'dd/MM/yyyy', new Date());
  
  return isValid(parsedDate)
  ? parsedDate.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    })
  : 'N/A';
}



export const transformYearWiseMonthSales = (data) => {
  const grouped = {};

  data.forEach(({ year, month, value }) => {
    if (!grouped[month]) {
      grouped[month] = { month };
    }
    grouped[month][year] = value;
  });

  return Object.values(grouped);
};
export const getSeriesFromData = (data) => {
  const yearsSet = new Set();
  data.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== 'month') {
        yearsSet.add(key);
      }
    });
  });

  return Array.from(yearsSet).map((year) => ({
    dataKey: year,
    label: `Year ${year}`,
    valueFormatter: (v) => `${v}`,
  }));
};
